import React from "react";
import "../../CSS/OrganisationCard.css";
import icon_park_build from "../../images/icon_park_build.svg";
import { FaHome, FaSearch, FaArrowUp } from "react-icons/fa";

const OrganisationCard = ({ city, organisation, link }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="org-card">
      <div>
        <img className="org-img" src={icon_park_build} alt={organisation} />
      </div>
      <p>
        <span>{city}</span>
        <span>{organisation}</span>
      </p>
      {/* <i className="fa-solid fa-arrow-up org-icon" aria-hidden="true"></i> */}
      <div className="org-icon">
      <FaArrowUp className="" />
      </div>
    </a>
  );
};

export default OrganisationCard;
